import { render, staticRenderFns } from "./MarqetaVirtualCardHosted.vue?vue&type=template&id=f2df5e6e&scoped=true"
import script from "./MarqetaVirtualCardHosted.vue?vue&type=script&lang=js"
export * from "./MarqetaVirtualCardHosted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2df5e6e",
  null
  
)

export default component.exports